/** Estado de filtros/paginação da listagem de Estados. */
export interface StateFilters {
  /** Texto de busca aplicado (client-side, por código, nome ou sigla). */
  readonly search: string;
  /** Página atual (1-indexed) da paginação client-side. */
  readonly page: number;
}

/** Estado inicial (sem busca, primeira página). */
export const INITIAL_STATE_FILTERS: StateFilters = {
  search: '',
  page: 1,
};
